module.exports = __webpack_public_path__ + "static/media/Aloftmuralprogress1.8a63ff82.webp";